import dayjs from 'dayjs'
import  utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
/**
 * 获取Unix时间戳/秒
 * @returns
 */
const getUnixTimestamp = (): number => {
  return Math.floor(Date.now() / 1000)
}

/**
 * 根据给定的格式化后的时间字符串，获取Unix时间戳/秒
 * @param timeStr
 * @returns
 */
const getUnixTimestampByStr = (timeStr?: string): number => {
  if (!timeStr) return getUnixTimestamp()
  return Math.floor(new Date(timeStr).getTime() / 1000)
}


/**
 * 转换时间为时间字符串   YYYY-MM-dd HH:mm:ss
 * @param date 
 */
const getTimeStr = (date?:Date)=>{
  const now = date??new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1; // 月份从0开始，所以加1
  const day = now.getDate();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  // const ms = now.getMilliseconds();
  
  const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return formattedDate + ' ' + formattedTime
}



/**
 * 时间戳转换为  YYY-MM-DD HH:mm:ss
 */

const getDateFormat = (timestamp: number) => {
  const  date = new Date(timestamp * 1000);

  // 提取年、月、日、小时、分钟和秒
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从 0 开始，需要加 1
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);

  // 构建日期时间字符串
  const formattedDateTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

  // 返回格式化后的日期时间字符串
  return formattedDateTime;
}



/**
 * 时间戳转换为  YYY-MM-DD HH:mm
 */

const getDateMidFormat = (timestamp: number) => {
  const  date = new Date(timestamp * 1000);

  // 提取年、月、日、小时、分钟和秒
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从 0 开始，需要加 1
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  // const seconds = ('0' + date.getSeconds()).slice(-2);

  // 构建日期时间字符串
  const formattedDateTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes 

  // 返回格式化后的日期时间字符串
  return formattedDateTime;
}



dayjs.extend(utc);
dayjs.extend(timezone)
/**
 * 将时间戳转换为 HH:mm:ss
 */
const getTimeFormat = (timestamp: number) => {
  const date = new Date(timestamp * 1000);
  // console.log(date);

  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

/**
 * 
 * @returns 时间戳转换为  YYY-MM-DD
 */

const getSmallDateFormat = (timestamp?: number, split: string = '-') => {
  let date = new Date  ()
  if(timestamp){
    date = new Date(timestamp * 1000);
  }
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2); 
  const day = ('0' + date.getDate()).slice(-2);

  const formattedDateTime = year + split + month + split + day 

  return formattedDateTime;
}
/**
 * 
 * @returns 时间抓换成 时间戳 11:30  =>  1630000000
 */
const getTimeToStr = (timeStr: string): number => {
    // 获取今天的日期
    const today = new Date();

    // 创建一个完整的日期时间对象
    const timeDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      parseInt(timeStr.split(':')[0], 10),
      parseInt(timeStr.split(':')[1], 10)
    );
  
    // 转换为时间戳
    return timeDate.getTime() / 1000
}

/**
 * 获取目标时区与本地时区的时间差
 * @param timezone
 * @returns 时差 秒钟
 */
const getTZOffsetByLocal = (timezone: string): number => {
  if (!timezone) return 0
  const localOffset = dayjs().utcOffset()
  const tarData = dayjs().tz(timezone)

  const tarOffset = tarData.utcOffset()
  return (localOffset - tarOffset) * 60
}

const getTimeOffset = (time: string | Date | number) => {
  if (typeof time === 'string') {
      //如果是字符串类型，则判断是否带有时区信息
      const timezoneRegex = /([+-]\d{2}):(\d{2})$/
      const matches = time.match(timezoneRegex)
      if (matches) {
          const hours = Number(matches[1]) // 获取时区的小时部分
          const minutes = Number(matches[2]) // 获取时区的分钟部分 
          return hours * 60 + minutes
      }
  }
  //如果不是字符串类型，则取本地时区偏移量
  const d = dayjs(time)
  return d.utcOffset()
}

/**
 * 获取目标时间戳，到给定时间戳的倒计时字符串 hh:mm:ss 格式
 * @param srcTimestamp 
 * @param tarTimestamp 
 * @returns 
 */
const getCountDownStr = (srcTimestamp:number, tarTimestamp:number)=>{
    if(srcTimestamp<=0 || tarTimestamp<=0) return '00:00:00'
    if(srcTimestamp<=tarTimestamp) return '00:00:00'
    let diffsecs = Math.floor((srcTimestamp-tarTimestamp)/1000)
    const h = Math.floor(diffsecs/3600)
    const m = Math.floor((diffsecs-h*3600)/60)
    const s = diffsecs-h*3600-m*60
    return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
}
// 根据时间戳获取日期格式  DD/MM/YYY HH:mm:ss
const  getDateFormatToDDMMYYYY =(timestamp: number,format: string = 'DD/MM/YYYY HH:mm:ss'): string =>{
  if (!timestamp && timestamp !== 0) return '';
  // 兼容 10 位秒级与 13 位毫秒级时间戳
  const ts = String(timestamp).length === 10 ? timestamp * 1000 : timestamp;
  const date = new Date(ts);

  const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

  const DD = pad(date.getDate());
  const MM = pad(date.getMonth() + 1);
  const YYYY = date.getFullYear();
  const HH = pad(date.getHours());
  const mm = pad(date.getMinutes());
  const ss = pad(date.getSeconds());

  return `${DD}/${MM}/${YYYY} ${HH}:${mm}:${ss}`;
}

// 根据格式化字符串获取日期格式 
/**
 * 根据格式化字符串获取日期格式
 * @param timestamp 时间戳
 * @param format 格式化字符串
 * @param isUTC 是否使用 UTC 时间
 * @returns 日期格式
 */
const getDateFormatByFormat = (timestamp: number | string, format: string = 'DD/MM/YYYY HH:mm:ss', isUTC: boolean = false): string => {
  if (!timestamp && timestamp !== 0) return '';

  // 兼容 10 位秒级与 13 位毫秒级时间戳
  const ts = String(timestamp).length === 10 ? Number(timestamp) * 1000 : Number(timestamp);
  const date = new Date(ts);

  const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

  // 根据 isUTC 判断使用本地时间还是 UTC 时间
  const DD = pad(isUTC ? date.getUTCDate() : date.getDate());
  const MM = pad(isUTC ? date.getUTCMonth() + 1 : date.getMonth() + 1);  // 月份从 0 开始，所以要加 1
  const YYYY = isUTC ? date.getUTCFullYear() : date.getFullYear();
  const YY = String(YYYY).slice(-2); // 两位年份
  const HH = pad(isUTC ? date.getUTCHours() : date.getHours());
  const mm = pad(isUTC ? date.getUTCMinutes() : date.getMinutes());
  const ss = pad(isUTC ? date.getUTCSeconds() : date.getSeconds());

  // 创建替换映射
  const formatMap: Record<string, string> = {
    'YYYY': YYYY.toString(),
    'YY': YY,
    'MM': MM,
    'DD': DD,
    'HH': HH,
    'mm': mm,
    'ss': ss
  };

  // 按照长度从长到短排序，避免替换冲突（如 YYYY 被 YY 部分替换）
  const sortedKeys = Object.keys(formatMap).sort((a, b) => b.length - a.length);

  let result = format;
  sortedKeys.forEach(key => {
    result = result.replace(new RegExp(key, 'g'), formatMap[key]);
  });

  return result;
}

export const useTimeUtil = () => ({ 
  getUnixTimestamp, 
  getUnixTimestampByStr,
  getTimeStr,
  getDateFormat,  
  getSmallDateFormat, 
  getDateMidFormat,
  getTimeToStr,
  getTimeFormat,
  getTZOffsetByLocal,
  getTimeOffset,
  getCountDownStr,
  getDateFormatToDDMMYYYY,
  getDateFormatByFormat

})
